import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Truck, Sparkles, ShieldCheck, Check } from "lucide-react";

const MESSAGES = [
  { icon: Truck, text: "Free express shipping Australia-wide" },
  { icon: ShieldCheck, text: "30-day money-back guarantee" },
  { icon: Sparkles, text: "Afterpay available · 4 easy payments" },
];

export const AnnouncementBar = () => {
  const { pathname } = useLocation();
  const isCheckoutFlow = pathname === "/cart" || pathname === "/checkout";

  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % MESSAGES.length), 3800);
    return () => clearInterval(id);
  }, []);

  if (isCheckoutFlow) {
    return (
      <div data-testid="announcement-bar" className="relative z-[60] overflow-hidden bg-[#FBC4A8] text-[#2C2B2C]">
        <div className="mx-auto flex max-w-[1400px] items-center justify-center gap-x-2 whitespace-nowrap px-4 py-2.5 text-[0.6rem] uppercase tracking-[0.12em] sm:gap-x-2.5 sm:px-6 sm:text-[0.66rem] sm:tracking-[0.2em]">
          <span className="flex h-4 w-4 flex-none items-center justify-center rounded-full bg-[#232222]">
            <Check className="h-2.5 w-2.5 text-[#FBC4A8]" strokeWidth={3.5} />
          </span>
          <span className="font-medium">Free Express Shipping Unlocked</span>
        </div>
      </div>
    );
  }

  const Msg = MESSAGES[i].icon;

  return (
    <div data-testid="announcement-bar" className="relative z-[60] overflow-hidden bg-[#FBC4A8] text-[#2C2B2C]">
      <div className="mx-auto flex max-w-[1400px] flex-nowrap items-center justify-center gap-x-2.5 whitespace-nowrap px-4 py-2.5 text-[0.6rem] uppercase tracking-[0.12em] sm:gap-x-8 sm:px-6 sm:text-[0.66rem] sm:tracking-[0.2em]">
        <span key={i} className="flex animate-[fadeIn_0.5s_ease] items-center gap-2 font-medium text-[#2C2B2C]">
          <Msg className="h-3.5 w-3.5" /> {MESSAGES[i].text}
        </span>
      </div>
    </div>
  );
};
